<template>
  <div class="container">
    <div class="title">
      <p class="wow fadeInUp" v-html="titlename">{{titlename}}</p>
    </div>
    <div class="redtext ">
      <div class="wow slideInLeft textspan">
<!--        <p>Professional impeller and blisk manufacturer in China</p>-->
        <span v-html="textContent">{{textContent}}
      </span>
      </div>

    </div>
<!--    <img src="../../../assets/imgs/about_img2.png"/>-->
    <img :src="imgsrc">
  </div>
</template>

<script>
  import {WOW} from 'wowjs';

  export default {
    name: "company",
    props: ['titlename','textContent','imgsrc'],
    mounted() {
      //解决---控制台可能会出现警告
      var options={
        //默认为true
        live:false
      }
      var wow = new WOW(options);
      wow.init();
    },
  }
</script>

<style lang="less" scoped>
  // 大于800px
  @media only screen and (min-width: 800px) {
    .container {
      position: relative;
      width: 100%;
      display: flex;
      flex-direction: column-reverse;
      justify-content: center;
      align-items: center;
      min-height: 500px;
      font-size: 1em;

      .title {
        position: absolute;
        top: 12%;
        left: 50%;
        width: 90%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        /*align-items: center;*/
        padding: 0px 0;
        font-size: 2em;
        z-index: 999;

        p {
          font-size: 1.4em;
          color: #2A1E4C;
        }
      }

      .redtext {
        position: absolute;
        top: 59%;
        left: 38%;
        width: 76%;
        height: 37%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;

        .textspan {
          overflow: hidden;
          text-align: left;
          padding: 2% 3% 2% 17%;
          background-color: rgba(139, 0, 0, 0.45);
          color: white;
          overflow: auto;
          p {
            font-size: 1.6em;
          }


          span {
            font-size: 1.2em;
            line-height: 1.3em;
          }
        }
        .textspan::-webkit-scrollbar {
          display: none;
        }
      }

      img {
        width: 100%;
        height: auto;
      }
    }
  }

  // 小于800px
  @media only screen and (max-width: 800px) {
    .container {
      position: relative;
      width: 100%;
      display: flex;
      flex-direction: column-reverse;
      justify-content: center;
      align-items: center;
      /*min-height: 500px;*/
      font-size: 1.5vw;

      .title {
        position: absolute;
        top: 12%;
        left: 50%;
        width: 90%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        /*align-items: center;*/
        padding: 0px 0;
        font-size: 2em;
        z-index: 999;

        p {
          font-size: 1.4em;
          color: #2A1E4C;
        }
      }

      .redtext {
        position: absolute;
        top: 50%;
        left: 38%;
        width: 78%;
        height: 40%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;

       .textspan {
         overflow: hidden;
          text-align: left;
          padding: 3% 3% 2% 10%;
          background-color: rgba(139, 0, 0, 0.45);
          color: white;
         overflow: auto;
          p {
            font-size: 1.2em;

            /*transform: scale(0.9);*/
          }

          span {
            /*margin-left: -5.2%;*/
            display: inline-block;
            font-size: 1.3em;
            /*font-size: 0.3em;*/
            line-height: 1.9vw;
          }
        }
        .textspan::-webkit-scrollbar {
          display: none;
        }
      }

      img {
        width: 100%;
        height: auto;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/About/aboutcomponents/company.vue